// extracted by mini-css-extract-plugin
module.exports = {"title":"OrderListHeader_title__FQNQz","btnAll":"OrderListHeader_btnAll__PqcmU"};